/**
 * Section
 *
 * Shared form-section wrapper used by every create/edit form in the
 * portal (PartForm, PlantForm, SupplierForm, TeamForm, AgreementForm).
 * Before this component existed each form carried its own local copy
 * of a section helper with slightly different styling — gray-uppercase
 * here, fieldset+legend there, bare h3 somewhere else. Consolidating
 * them into one file is what keeps the forms visually consistent.
 *
 * Visual spec:
 *   - Orange (brand-primary) h3 heading, size 14, Title Case.
 *   - An optional right-aligned action slot beside the title, for
 *     "+ Add …" buttons on repeater sections.
 *   - A thin `--brand-border` rule below the section, so sections
 *     read as distinct blocks. Disable with `divider={false}` (e.g.,
 *     when the section is the last one before the footer and the
 *     form's own <hr> above the Save/Cancel row is doing the job).
 *
 * Props:
 *   title   — string shown in the heading
 *   action  — optional node rendered to the right of the title
 *   divider — whether to render the trailing <hr> (default true)
 *   children
 */
export default function Section({ title, action, divider = true, children }) {
  return (
    <div style={{ marginBottom: 20 }}>
      {(title || action) && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            marginBottom: 10,
            gap: 8,
          }}
        >
          {title && (
            <h3
              style={{
                margin: 0,
                fontSize: 14,
                color: 'var(--brand-primary)',
              }}
            >
              {title}
            </h3>
          )}
          {action}
        </div>
      )}
      {children}
      {divider && (
        <hr
          style={{
            margin: '20px 0 0',
            border: 'none',
            borderTop: '1px solid var(--brand-border)',
          }}
        />
      )}
    </div>
  );
}
